import { useState, useCallback }    from 'react';
import { votacaoRepository }        from '../../data/votacaoRepository';

export interface FutebolVotacaoAdminState {
  operando:         boolean;
  erro:             string | null;
  limparErro:       () => void;
  iniciarVotacao:   () => Promise<void>;
  encerrarVotacao:  () => Promise<void>;
}

export function useFutebolVotacaoAdmin(empresaId?: string): FutebolVotacaoAdminState {
  const [operando, setOperando] = useState(false);
  const [erro, setErro]         = useState<string | null>(null);

  const limparErro = useCallback(() => setErro(null), []);

  const iniciarVotacao = useCallback(async () => {
    setOperando(true);
    setErro(null);
    try {
      await votacaoRepository.iniciarVotacao(empresaId);
    } catch (err) {
      const msg = err && typeof err === 'object' && 'message' in err
        ? String((err as { message: string }).message)
        : 'Erro ao iniciar votação';
      setErro(msg);
    } finally {
      setOperando(false);
    }
  }, [empresaId]);

  const encerrarVotacao = useCallback(async (): Promise<void> => {
    setOperando(true);
    setErro(null);
    try {
      await votacaoRepository.encerrarVotacao(empresaId);
    } catch (err) {
      const msg = err && typeof err === 'object' && 'message' in err
        ? String((err as { message: string }).message)
        : 'Erro ao encerrar votação';
      setErro(msg);
    } finally {
      setOperando(false);
    }
  }, [empresaId]);

  return { operando, erro, limparErro, iniciarVotacao, encerrarVotacao };
}
